import { Immutable } from "immer";

import { templates } from "@reactivated";

export type ComparePageLegacyBodySegment =
    | "legacy_c_top"
    | "legacy_c_bottom"
    | "legacy_purple_top"
    | "legacy_purple_bottom";
type BodyBlock =
    templates.ComparePageVariantCTemplate["page"]["body"]["value"][number];
type BodyBlockType = BodyBlock["type"];

const isReviewStyle = (
    block: Immutable<BodyBlock>,
    style: "pull" | "full",
): boolean => block.type === "reviews" && block.value.style === style;

const inTypes = (
    block: Immutable<BodyBlock>,
    types: ReadonlyArray<BodyBlockType>,
): boolean => types.includes(block.type);

const isLegacyCTopBlock = (block: Immutable<BodyBlock>): boolean =>
    inTypes(block, [
        "comparison_block",
        "cta_section_upper",
        "highlight_bar",
        "shipping_estimation_bar",
    ]);

const isLegacyCBottomBlock = (block: Immutable<BodyBlock>): boolean =>
    isReviewStyle(block, "pull") ||
    isReviewStyle(block, "full") ||
    inTypes(block, [
        "mattress_feel",
        "mattress_difference",
        "mattress_chart",
        "cta_section_lower",
        "delivered_in_box",
        "oprah",
        "video_bar",
        "promise",
    ]);

const isLegacyPurpleBottomBlock = (block: Immutable<BodyBlock>): boolean =>
    inTypes(block, ["cta_section_lower", "promise"]);

const segmentRenderers: Record<
    ComparePageLegacyBodySegment,
    (block: Immutable<BodyBlock>) => boolean
> = {
    legacy_c_top: isLegacyCTopBlock,
    legacy_c_bottom: isLegacyCBottomBlock,
    legacy_purple_top: (block) => !isLegacyPurpleBottomBlock(block),
    legacy_purple_bottom: isLegacyPurpleBottomBlock,
};

export const filterComparePageBodySegment = (
    blocks: Immutable<BodyBlock[]>,
    segment: ComparePageLegacyBodySegment,
): Immutable<BodyBlock[]> =>
    blocks.filter((block) => segmentRenderers[segment](block));
